import React from 'react';
import {ReactComponent as Logo } from '../Images/vlhIcon.svg';
import "./Header.css";

function Header() {
  return (
    <div id='header'>
        <Logo id='vlhIcon' alt="VLH Logo" aria-label="The vision loss hub logo. It is an eye with lines across it to indicate sight loss." />
        <div id='title'>
            <div id='vlh'>Vision Loss Hub</div>
            <div id='sws'>Stronger with Support</div>
        </div>
    </div>
  )
}

export default Header